<script>
export default {
  props: {
    onExportOptions: {
      type: Function,
      required: true,
    },
  },
}
</script>
